import api from './api';
// 获得工作列表信息
export function jobList(params) {
  return api.post('/join/getJobList', params, true, false);
}

// 获得工作详细信息
export function jobInfo(params) {
  return api.post('/join/getJob', params, true, false);
}



// WEBPACK FOOTER //
// ./src/api/frontApi/join.js